import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BaseHelper } from '../baseHelper';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private b: BaseHelper) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if ((error.status === 401 || error.status === 403) && !req.url.includes('/public/')) {
          this.b.clearJws();
          this.b.toast('Session expired. Please log in again.', 2000, 'warning');
          this.router.navigateByUrl('/login');
        }
        return throwError(() => error);
      })
    );
  }
}
